export default __webpack_public_path__ + "static/media/callIcon.029ee7c0.svg";